import React from 'react';
import classnames from 'classnames';
import { InputAdornment } from 'tea-component';
import NumberInput, { INumberInputProps } from '@gp/components/NumberInput';

import '@gp/components/CurrencyInput/index.scss';

interface ICurrencyInputProps extends INumberInputProps {
  // 货币单位，默认为M
  currencyUnit?: string;
  inputStyle?: React.CSSProperties;
  inputClassName?: string;
}

const CurrencyInput: React.FC<ICurrencyInputProps> = (props) => {
  const { style, className, inputStyle, inputClassName, currencyUnit = 'M', ...restProps } = props;

  return (
    <InputAdornment style={style} className={classnames('dbg-common-currency-input', className)} after={currencyUnit}>
      <NumberInput {...restProps} style={inputStyle} className={inputClassName} />
    </InputAdornment>
  );
};

export default CurrencyInput;
